import { Mic, Square } from "lucide-react";
import { useEffect, useRef, useState } from "react";

const Recognition = typeof window !== "undefined" ? window.SpeechRecognition || window.webkitSpeechRecognition : null;

export function MicTextarea({ value, onChange, onAudio }) {
  const [listening, setListening] = useState(false);
  const rec = useRef(null);
  const base = useRef("");
  const recorder = useRef(null);
  const chunks = useRef([]);

  useEffect(() => () => { rec.current?.abort(); recorder.current?.stream.getTracks().forEach((t) => t.stop()); }, []);

  const startRecording = async () => {
    if (recorder.current?.state === "paused") { recorder.current.resume(); return; }
    if (recorder.current || !window.MediaRecorder || !navigator.mediaDevices?.getUserMedia) return;
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      const mr = new MediaRecorder(stream);
      mr.ondataavailable = (e) => { if (e.data.size) chunks.current.push(e.data); };
      mr.start();
      recorder.current = mr;
      const finalize = () => new Promise((resolve) => {
        if (mr.state === "inactive") { resolve(new Blob(chunks.current, { type: mr.mimeType || "audio/webm" })); return; }
        mr.onstop = () => { stream.getTracks().forEach((t) => t.stop()); resolve(new Blob(chunks.current, { type: mr.mimeType || "audio/webm" })); };
        mr.stop();
      });
      onAudio?.(() => finalize);
    } catch { recorder.current = null; }
  };
  const stopRecording = () => { if (recorder.current?.state === "recording") recorder.current.pause(); };

  const toggle = () => {
    if (listening) { rec.current?.stop(); stopRecording(); return; }
    const r = new Recognition();
    r.lang = "fr-FR";
    r.continuous = true;
    r.interimResults = true;
    base.current = value ? `${value.trimEnd()} ` : "";
    r.onresult = (e) => {
      let text = "";
      for (let i = 0; i < e.results.length; i += 1) text += e.results[i][0].transcript;
      onChange(base.current + text.trim());
    };
    r.onend = () => { setListening(false); stopRecording(); };
    r.onerror = () => { setListening(false); stopRecording(); };
    rec.current = r;
    r.start();
    startRecording();
    setListening(true);
  };

  return (
    <div className={`lp-mic lp-full${listening ? " on" : ""}`}>
      <textarea rows={3} placeholder={Recognition ? "Votre message (vous pouvez aussi le dicter)" : "Votre message"} value={value} onChange={(e) => onChange(e.target.value)} maxLength={3000} data-testid="contact-message" />
      {Recognition && (
        <button type="button" onClick={toggle} aria-label={listening ? "Arrêter la dictée" : "Dicter le message"} data-testid="contact-mic">
          {listening ? <Square size={14} /> : <Mic size={17} />}<span>{listening ? "Stop" : "Dicter"}</span>
        </button>
      )}
    </div>
  );
}
